import React from "react";
import css from "./main-menu.module.scss";

interface MainMenuSectionProps
{
    children?: React.ReactNode;
    mobileHeight: number;
    title: string;
}

export const MainMenuSection = ({ children, mobileHeight, title }: MainMenuSectionProps): React.FunctionComponentElement<MainMenuSectionProps> =>
    <div className={css["section"]} data-main-menu-section data-collapsed style={{ ["--mobile-height" as string]: `${mobileHeight}px` }}>
        <div className={css["header"]} data-main-menu-header>
            <span className={css["title"]}>{title}</span>
            <svg width="15" height="10" viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.812509 0.841814L8.31247 8.34177L7.49996 9.15428L0 1.65432L0.812509 0.841814Z" />
                <path d="M6.6875 8.34375L14.1885 0.842785L15.001 1.65529L7.50001 9.15626L6.6875 8.34375Z" />
            </svg>
        </div>
        <div className={css["content"]}>
            {children}
        </div>
    </div>;
